import { useQuery } from "@apollo/react-hooks"
import gql from "graphql-tag"

// le post est branche depuis l'admin du blog (edition + emplacement), pas dans ce code
export default function useInterviewLink(edition) {
  const { data } = useQuery(
    gql`
      query EditionHomeLinks($editionId: ID!) {
        edition(id: $editionId) {
          id
          homeLinks {
            key
            slug
          }
        }
      }
    `,
    { variables: { editionId: edition.id } }
  )
  return (key) => {
    if (!data || !data.edition) return null
    const homeLink = data.edition.homeLinks.find((link) => link.key === key)
    return homeLink
      ? { label: t(`global.read-interview`), to: `/blog/${homeLink.slug}/` }
      : { label: t(`global.interview-coming-soon`) }
  }
}
